<template>
  <div>
    <vs-card>
   
      <b-row align-h="start" >
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="start"
            v-model="startDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="end"
            v-model="endDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px">
          <b-button
            style="border-color: white"
            v-on:click="filterStockTrans()"
            class="bg-primary vs-con-loading__container"
            id="loading-stock-move"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("List") }}
          </b-button>
        </b-col>
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px">
          <b-button
            style="border-color: white"
            v-on:click="filterStockTransAll()"
            class="bg-primary vs-con-loading__container"
            id="loading-stock-move-all"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("AllList") }}
          </b-button>
        </b-col>
        <b-col :cols="isMobile() ? 12 : 3" md="auto" style="padding-right: 2px" v-if="ROLE != 'Company'">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="addStockMovements()"
          >
            <Icon
              icon="mingcute:add-line"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("AddStockMovements") }}
          </b-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <vs-popup
      class="holamundo"
      :title="$t('StocktransDetail') + ' (' + infoData.StockTransCode + ') '"
      :active.sync="isSstocktransDetailPopup"
      @close="closeDetailPopup"
      @cancel="closeDetailPopup"
      fullscreen
    >
      <StockTransDetails :data="infoData" :type="'head'" @getList="filterStockTrans"/>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import StockTransDetails from "./StockTransDetails.vue";
import moment from "moment";
import getShelfTransStatus from "./CellRenderers/getShelfTransStatus.vue";
import { isMobile } from "mobile-device-detect";

export default {
  data() {
    return {
      isMobile: function () {
        return isMobile;
      },
      ROLE: this.$store.state.AppActiveUser.ROLE,
      locale: "de",
      weekday: 1,
      isSstocktransDetailPopup: false,
      addNewInfoDataSidebar: false,
      isPromptActiveEmployeeLocal: false,
      addNewActSidebar: false,
      infoData: [],
      endDate: "",
      startDate: "",
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    StockTransDetails,
    getShelfTransStatus,
    detailBtnCellRenderer,
    AgGridVue,
    Icon,
  },

  methods: {
    closeDetailPopup() {
     // this.filterStockTrans();
    },
    addStockMovements() {
      this.$router
        .push({
          name: "StockMovement",
        })
        .catch(() => {});
    },
    editStockTrans() {
      this.isSstocktransDetailPopup = true;
    },
    parseDate(params) {
      return moment(String(params)).format("YYYY-MM-DD");
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getStockColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          pinned: "left",
          width: 130,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "editStockTrans",
            iconDetail: "uil:search",
            iconColor: "#065a82",
          },
        });

        columnList.forEach((val, index) => {
          if ((val == "CompanyName" || val == "Barcode" || val == "Description") && !this.isMobile()) {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("TrasnType") == false
          ) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    filterStockTransAll() {
      const vs = this.$vs;
      let type = "material";

      vs.loading({
        container: `#loading-stock-move-all`,
        type,
        scale: 0.5,
      });
      this.startDate =
        this.startDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() - 30)))
          : this.parseDate(moment(String(this.startDate)).format("YYYY-MM-DD"));
      this.endDate =
        this.endDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() + 1)))
          : this.parseDate(moment(String(this.endDate)).format("YYYY-MM-DD"));
      let obj = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.$store
        .dispatch("stock/listStockTransAllForRole", obj)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-stock-move-all > .con-vs-loading");
            }, 1000);
            try {
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-stock-move-all > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-stock-move-all > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    filterStockTrans() {
      const vs = this.$vs;
      let type = "material";

      vs.loading({
        container: `#loading-stock-move`,
        type,
        scale: 0.5,
      });
      this.startDate =
        this.startDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() - 30)))
          : this.parseDate(moment(String(this.startDate)).format("YYYY-MM-DD"));
      this.endDate =
        this.endDate == ""
          ? this.parseDate(new Date(new Date().setDate(new Date().getDate() + 1)))
          : this.parseDate(moment(String(this.endDate)).format("YYYY-MM-DD"));
      let obj = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.$store
        .dispatch("stock/listStockTransForRole", obj)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-stock-move > .con-vs-loading");
            }, 1000);
            try {
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-stock-move > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-stock-move > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
  },
  computed: {
    stockItemsAll: {
      get() {
        return this.$store.state.stock.StockItemsAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stockTransAll: {
      get() {
        return this.$store.state.stock.StockTransAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.locale = this.$i18n.locale == "en" ? "en-US" : this.$i18n.locale;
    this.filterStockTrans();

    this.$root.$on("employeeDetail", (data) => {
      this.infoData = data;
      this.employeeDetail(data);
    });
    this.$root.$on("editStockTrans", (data) => {
      this.infoData = data;
      this.editStockTrans(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("employeeDetail");
    this.$root.$off("editStockTrans");
  },
  watch: {
    stockItemsAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getStockColumnList();
      }
      return val;
    },
    stockTransAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getStockColumnList();
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
